import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'buscarPedido'
})
export class BuscarPedidoPipe implements PipeTransform {
  constructor() {
  }
    transform(value: any, term): any {
        if(value){
            return value.filter((item)=> {
                let existe = item.folio.includes(term);
                if(!existe){
                    existe = item.personas.nombre.includes(term);
                }
                return existe;
            });
        }
        else return false;
    }
}
